import { FlowHttpRequestOptions, mixHeadersOptions, pick } from '@snfe/flow-yapi-helpers';
import * as model from '@/model';
import http from '../http';

/**
 * @desc id=1520930, catid=258301, projectId=41427, created=2025-05-21 00:51:31, last-modified=2025-05-22 11:18:16
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commAdminApi/user/verification/user/getUserVerifications)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520930)
 */
export function postCommAdminApiUserVerificationUserGetUserVerifications(
  params: model.commAdminApi.IPostCommAdminApiUserVerificationUserGetUserVerificationsParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commAdminApi.IPostCommAdminApiUserVerificationUserGetUserVerificationsResponse>(
    '/commAdminApi/user/verification/user/getUserVerifications',
    {
      data: pick(params, ['userId']),
      ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
    }
  );
}

/**
 * @desc id=1520938, catid=258301, projectId=41427, created=2025-05-21 00:52:11, last-modified=2025-05-22 11:19:19
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commAdminApi/notification/user/getAllNotifications)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520938)
 */
export function postCommAdminApiNotificationUserGetAllNotifications(
  params: model.commAdminApi.IPostCommAdminApiNotificationUserGetAllNotificationsParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commAdminApi.IPostCommAdminApiNotificationUserGetAllNotificationsResponse>(
    '/commAdminApi/notification/user/getAllNotifications',
    {
      data: pick(params, ['userId']),
      ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
    }
  );
}

/**
 * @desc id=1520610, catid=258301, projectId=41427, created=2025-05-15 19:43:45, last-modified=2025-05-22 11:23:37
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commAdminApi/user/verification/review)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520610)
 */
export function postCommAdminApiUserVerificationReview(
  params: model.commAdminApi.IPostCommAdminApiUserVerificationReviewParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commAdminApi.IPostCommAdminApiUserVerificationReviewResponse>('/commAdminApi/user/verification/review', {
    data: pick(params, ['verificationId', 'approved', 'rejectReason']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521080, catid=258301, projectId=41427, created=2025-05-22 13:10:12, last-modified=2025-05-22 13:10:28
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commAdminApi/user/verification/getVerificationList)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521080)
 */
export function postCommAdminApiUserVerificationGetVerificationList(
  params: model.commAdminApi.IPostCommAdminApiUserVerificationGetVerificationListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commAdminApi.IPostCommAdminApiUserVerificationGetVerificationListResponse>(
    '/commAdminApi/user/verification/getVerificationList',
    {
      data: params,
      ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
    }
  );
}
